<template>
  <v-container fluid class="region-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/region/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="regions-table"
              show-select
              single-select
              item-key="_id"
              sort-by="regionname"
              :footer-props="footer"
              :headers="headers"
              :items="regions"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Region?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteRegion.regionname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteRegion)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.regionname="{ item }">
                <p class="two-line"><strong>{{ item.regionname }}</strong></p>
                <p class="two-line">{{ item.regioninfo  }}</p>
              </template>
              <template v-slot:item.regionemail="{ item }">
                <a class="primaryConst--text">{{ item.regionemail }}</a>
              </template>
              <template v-slot:item.regionid="{ item }">
                {{ item.regionid }}
              </template>
              <template v-slot:item.company>
                Flatlogic
              </template>
              <template v-slot:item.regionstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.regionstatus)"
                  small>
                  {{ item.regionstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStatusColor} from '@/util/tools';

export default {
  name: 'regionList',
  data() {
    return {
      snackbar: null,
      dialog: false,
      deleteRegion: {},
      headers: [
        { text: 'Type', value: 'regiontype' },
        { text: 'Name', value: 'regionname' },
        { text: 'Code', value: 'regioncode' },
        { text: 'Status', value: 'regionstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      switch1: true,
      getStatusColor: getStatusColor
    }
  },

  computed: {
    ...mapState('Region', ['regions', 'isReceiving', 'isDeleting', 'idToDelete', 'regionsMessage', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit region'
    },
  },
  created () {
    this.getRegionsRequest()
  },
  methods: {
    ...mapActions('Region', ["getRegionsRequest","deleteRegionRequest","updateRegionRequest","insertRegionRequest"]),
    editItem(item) {
      this.$router.push({ name: 'RegionEdit', params: item })
    },
    deleteItem(item) {
      this.deleteRegionRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteRegion = {
        _id: item._id,
        regionname: item.regionname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
